// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://solar.energcoiraq.com/api';

// Area Calculation API (optional - if not set, will use local calculation)
export const AREA_CALCULATION_API_URL = process.env.REACT_APP_AREA_CALCULATION_API_URL || null;

